<div class="select-option">
  <div class="option-row">
    @if (isHeader) {
      @for (field of fields; track field) {
        <div class="cell">
          <strong class="text-capitalize">{{
            getLabel(field) | translate
          }}</strong>
        </div>
      }
    } @else {
      @for (field of fields; track field) {
        <div class="cell">
          @if (badgeFieldSet.has(field)) {
            <span
              class="badge"
              [ngClass]="getBadgeClass(row[field])"
              >
              {{
              (row[field] ? "LINKED TO MY SITE" : "NOT LINKED")
              | translate
              }}
            </span>
          } @else {
            {{ row[field] ?? "-" }}
          }
        </div>
      }
    }
  </div>
</div>
